var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Prop, Watch } from 'vue-property-decorator';
import Component from 'vue-class-component';
import PurchaseRefundForUpperSupService from '../../../api/PurchaseRefundForUpperSupService';
import EHanldeStatus from '../../../enum/EHandleStatus';
import { EOrderSubType } from "../../../enum/EUpperPurchase";
import HeaderItem from "../../../components/HeaderItem";
import OrderPicDialog from "./OrderPicDialog.vue";
var default_1 = (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.eHanldeStatus = EHanldeStatus;
        _this.eOrderSubType = EOrderSubType;
        _this.accountOptions = [];
        _this.supplierupperOptions = [];
        _this.supplierorganOptions = [];
        _this.supplierdepotOptions = [];
        _this.orderSubTypeOptions = [
            {
                id: 3,
                name: '有单退货'
            },
            {
                id: 4,
                name: '无单退货'
            }
        ];
        _this.upperWareHouseOrderCodeOptions = [];
        return _this;
    }
    default_1.prototype.watchFormDataSupplierUpperId = function (newVal, oldVal) {
        if (this.handleStatus === EHanldeStatus.Edit) {
            return;
        }
        if (newVal) {
            if (oldVal) {
                this.formData.organ_id = '';
                this.$emit('emptyGood');
                this.formData.upper_warehouse_order_id = '';
            }
            this.getSupplierorganOptions();
            this.filterSearchUpperWarehouseOrderCode();
        }
        else {
            this.supplierorganOptions = [];
            this.formData.organ_id = '';
            this.upperWareHouseOrderCodeOptions = [];
            this.formData.upper_warehouse_order_id = '';
        }
    };
    default_1.prototype.watchFormDataOrganId = function (newVal, oldVal) {
        if (this.handleStatus === EHanldeStatus.Edit) {
            return;
        }
        if (newVal) {
            if (oldVal) {
                this.formData.depot_id = '';
                this.$emit('emptyGood');
                this.formData.upper_warehouse_order_id = '';
            }
            this.getSupplierdepotOptions();
            this.filterSearchUpperWarehouseOrderCode();
        }
        else {
            this.supplierdepotOptions = [];
            this.formData.depot_id = '';
            this.upperWareHouseOrderCodeOptions = [];
            this.formData.upper_warehouse_order_id = '';
        }
    };
    default_1.prototype.watchFormDataDepotId = function (newVal, oldVal) {
        if (this.handleStatus === EHanldeStatus.Edit) {
            return;
        }
        if (newVal) {
            if (oldVal) {
                this.$emit('emptyGood');
                this.formData.upper_warehouse_order_id = '';
            }
            this.filterSearchUpperWarehouseOrderCode();
        }
        else {
            this.upperWareHouseOrderCodeOptions = [];
            this.formData.upper_warehouse_order_id = '';
        }
    };
    default_1.prototype.watchFormDataOrderSubType = function (newVal, oldVal) {
        if (this.handleStatus === EHanldeStatus.Edit) {
            return;
        }
        this.$emit('emptyGood');
        if (oldVal) {
            if (newVal == EOrderSubType['无单退货']) {
                this.formData.upper_warehouse_order_id = '';
            }
            else {
                this.filterSearchUpperWarehouseOrderCode();
            }
        }
    };
    default_1.prototype.watchFormDataUpperWarehouseOrderCode = function (newVal, oldVal) {
        if (this.handleStatus === EHanldeStatus.Edit) {
            return;
        }
        if (newVal) {
            if (oldVal) {
                this.$emit('emptyGood');
            }
            var rows = this.upperWareHouseOrderCodeOptions.filter(function (item) { return item.order_id == newVal; });
            this.formData.upper_warehouse_order_code = rows[0] ? rows[0].order_code : '';
            this.resetGoodByUpperWarehouseOrderCode();
        }
        else {
            this.formData.upper_warehouse_order_code = '';
        }
        console.log(this.formData.upper_warehouse_order_code);
    };
    default_1.prototype.created = function () {
        this.service = PurchaseRefundForUpperSupService.getInstance();
        if (this.handleStatus === EHanldeStatus.Add) {
            this.getSupplierupperOptions();
        }
        this.getAccountOptions();
    };
    default_1.prototype.mounted = function () { };
    default_1.prototype.getSupplierupperOptions = function (val) {
        var _this = this;
        var params = {
            keyword: val || ''
        };
        this.service.getSupplierupperOptions(params).then(function (res) {
            if (res.data.success) {
                _this.supplierupperOptions = res.data.data;
            }
        });
    };
    default_1.prototype.getSupplierorganOptions = function () {
        var _this = this;
        var params = {
            supplier_upper_id: this.formData.supplier_upper_id,
        };
        this.service.getSupplierorganOptions(params).then(function (res) {
            if (res.data.success) {
                _this.supplierorganOptions = res.data.data;
                _this.formData.organ_id = res.data.data && res.data.data[0].organ_id || '';
            }
        });
    };
    default_1.prototype.getSupplierdepotOptions = function () {
        var _this = this;
        var params = {
            organ_id: this.formData.organ_id,
            is_init: 1
        };
        this.service.getSupplierdepotOptions(params).then(function (res) {
            if (res.data.success) {
                _this.supplierdepotOptions = res.data.data;
                (res.data.data || []).some(function (item) {
                    if (item.is_organ_default == 1) {
                        _this.formData.depot_id = item.depot_id;
                        return true;
                    }
                    _this.formData.depot_id = '';
                });
            }
        });
    };
    default_1.prototype.getAccountOptions = function () {
        var _this = this;
        var params = {
            organ_id: this.formData.organ_id
        };
        this.service.getAccountOptions().then(function (res) {
            if (res.data.success) {
                _this.accountOptions = res.data.data;
            }
        });
    };
    default_1.prototype.filterSearch = function (val) {
        var _this = this;
        clearTimeout(this.time);
        this.time = setTimeout(function () {
            _this.getSupplierupperOptions(val);
        }, 500);
    };
    default_1.prototype.getUpperWareHouseOrderCodeOptions = function (val) {
        var _this = this;
        var params = {
            supplier_upper_id: this.formData.supplier_upper_id,
            organ_id: this.formData.organ_id,
            depot_id: this.formData.depot_id,
            keyword: val || ''
        };
        if (!this.formData.supplier_upper_id) {
            this.upperWareHouseOrderCodeOptions = [];
        }
        this.service.getUpperWareHouseOrderCodeOptions(params).then(function (res) {
            if (res.data.success) {
                _this.upperWareHouseOrderCodeOptions = res.data.data;
            }
        });
    };
    default_1.prototype.filterSearchUpperWarehouseOrderCode = function (val) {
        var _this = this;
        clearTimeout(this.upperWareHouseOrderCodeTime);
        this.upperWareHouseOrderCodeTime = setTimeout(function () {
            _this.getUpperWareHouseOrderCodeOptions(val);
        }, 500);
    };
    default_1.prototype.resetGoodByUpperWarehouseOrderCode = function () {
        var _this = this;
        var params = {
            supplier_upper_id: this.formData.supplier_upper_id,
            organ_id: this.formData.organ_id,
            depot_id: this.formData.depot_id,
            order_id: this.formData.upper_warehouse_order_id,
        };
        this.service.getGoodByUpperWarehouseOrderCode(params).then(function (res) {
            if (res.data.success) {
                var data = res.data.data || [];
                data = data.map(function (item) {
                    return __assign({}, item, { order_detail_warehouse_amount: item.order_detail_amount, order_detail_amount: item.order_detail_amount, order_detail_uprice: item.order_detail_uprice || item.goods_price });
                });
                _this.$emit('resetGood', data);
            }
        });
    };
    default_1.prototype.toOrderPic = function () {
        var _this = this;
        var dialog = this.$dialog(OrderPicDialog, {
            data: {
                pics: this.formData.certificate_img
            }
        }, {
            title: "上传图片",
            width: 900,
            height: 550
        });
        dialog.instance.$on("submit", function (res) {
            _this.formData.certificate_img = res;
        });
    };
    __decorate([
        Prop({
            required: true
        })
    ], default_1.prototype, "formData", void 0);
    __decorate([
        Prop({
            required: true,
            type: Number
        })
    ], default_1.prototype, "handleStatus", void 0);
    __decorate([
        Watch('formData.supplier_upper_id')
    ], default_1.prototype, "watchFormDataSupplierUpperId", null);
    __decorate([
        Watch('formData.organ_id')
    ], default_1.prototype, "watchFormDataOrganId", null);
    __decorate([
        Watch('formData.depot_id')
    ], default_1.prototype, "watchFormDataDepotId", null);
    __decorate([
        Watch('formData.order_sub_type')
    ], default_1.prototype, "watchFormDataOrderSubType", null);
    __decorate([
        Watch('formData.upper_warehouse_order_id')
    ], default_1.prototype, "watchFormDataUpperWarehouseOrderCode", null);
    default_1 = __decorate([
        Component({
            components: {
                HeaderItem: HeaderItem
            }
        })
    ], default_1);
    return default_1;
}(Vue));
export default default_1;
